import React, { useEffect, useState } from 'react'
import styles from './StatusMultiEditor.module.scss'
import { ArrowSvg } from '../Icons'
import StatusColor from '../StatusColor'
import cn from 'classnames'
import { Button, CircularProgress } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/reducers/root.reducer'
import { setStatusesThunk } from '../../redux/vessels/main.action'
import { IStatus, IVessel } from '../../types/global.types'
import { getFiltersRequest } from '../../api/search.api'

interface IStatusMultiEditorProps {}

const StatusMultiEditor: React.FC<IStatusMultiEditorProps> = () => {
  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = useState(false)
  const [statusList, setStatusList] = useState<Array<IStatus>>([])
  const [activeStatus, setActiveStatus] = useState<IStatus | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const selectedIds: Array<number> = useSelector(
    (state: RootState) => state.main.list
  )
    .filter((item: IVessel) => item.is_selected)
    .map((item: IVessel) => item.id)

  function handleStatusClick(event: React.SyntheticEvent<HTMLButtonElement>) {
    const id = parseInt(event.currentTarget.name)
    setActiveStatus(statusList.find((item) => item.id === id) || null)
  }

  function handleApply() {
    if (activeStatus) {
      setIsOpen(false)
      setActiveStatus(null)
      dispatch(setStatusesThunk(activeStatus, selectedIds))
    }
  }

  useEffect(() => {
    if (isOpen) {
      setLoading(true)
      getFiltersRequest(['status']).then(({ status }) => {
        setLoading(false)
        setStatusList(status)
      })
    }
  }, [isOpen])

  const isApplyDisabled = !activeStatus || !selectedIds.length
  return (
    <div className={styles.block}>
      <div className={styles.select} onClick={() => setIsOpen(!isOpen)}>
        <span className={styles.select_text}>Change Statuses</span>
        <ArrowSvg rotate={isOpen} />
      </div>

      {isOpen && (
        <div className={styles.statuses}>
          {loading ? (
            <CircularProgress />
          ) : (
            statusList.map(({ name, id, color }) => (
              <button
                onClick={handleStatusClick}
                name={id?.toString()}
                className={cn(styles.status_button, {
                  [styles.active]: id === activeStatus?.id,
                })}
                key={id}
              >
                <span>{name}</span>
                <StatusColor
                  color={color}
                  style={{ position: 'static', transform: 'unset' }}
                />
              </button>
            ))
          )}
          <Button
            className={styles.apply_button}
            onClick={handleApply}
            disabled={isApplyDisabled}
            color="primary"
            size="small"
            variant="outlined"
          >
            Apply
          </Button>
        </div>
      )}
    </div>
  )
}

export default StatusMultiEditor
